import { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padded?: boolean;
  pressable?: boolean;
}

/** Card base: el resto de tarjetas del sistema (StatCard, KpiCard...) se construyen sobre esta. */
export function Card({ children, padded = true, pressable = false, className = '', ...rest }: CardProps) {
  return (
    <div
      className={[
        'rounded-2xl border border-ink-100 bg-surface shadow-soft transition-all duration-200',
        padded ? 'p-4' : '',
        pressable ? 'cursor-pointer active:scale-[0.98] hover:shadow-card' : '',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
}

export function Section({ title, action, children }: { title: string; action?: ReactNode; children: ReactNode }) {
  return (
    <section className="mb-6">
      <div className="mb-3 flex items-center justify-between px-1">
        <h2 className="text-[15px] font-semibold text-ink-800">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
